import React, { Component } from 'react';
import { Quill } from '../../components';
import 'animate.css/animate.min.css';
import './element-text-two-column.css';

export default class ElementTextTwoColumn extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(position, text) {
    var content = this.props.content;
    content.items[position] = text;
    this.props.onChange(content);
  }

  getFont(font) {
    if (font) return font.replace(/\s/g, '-').toLowerCase();
  }

  render() {
    let { headerActionsTemplate, footerActionsTemplate, content, className } = this.props;

    var textStyle = {
      background: content.background_color,
      paddingTop: content.padding_top + "px",
      paddingBottom: content.padding_bottom + "px"
    };

    return <div className={`${className} rdp-element-text-two-column ${this.getFont(content.font_family) || ""}`} style={textStyle}>
      {this.props.editable ? (
        <>
          {headerActionsTemplate}
          <div className="rdp-element-text-two-column-items">

              <div className="rdp-element-text-two-column-item first">
                <Quill
                  value={content.items[0]}
                  onChange={(text) => this.handleChange(0, text)}
                />
              </div>
              <div className="rdp-element-text-two-column-item last">
                <Quill
                  value={content.items[1]}
                  onChange={(text) => this.handleChange(1, text)}
                />
              </div>

          </div>
          {footerActionsTemplate}
        </>
      ) : (
        <div className="rdp-element-text-two-column-items">
          <div className="rdp-element-text-two-column-item first">
            <div className="editor" dangerouslySetInnerHTML={{__html: content.items[0]}}></div>
          </div>
          <div className="rdp-element-text-two-column-item last">
            <div className="editor" dangerouslySetInnerHTML={{__html: content.items[1]}}></div>
          </div>
        </div>
      )}
    </div>;
  }
}
